var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"isLoggedIn":_vm.isLoggedIn,"user":_vm.user},on:{"login":_vm.login,"logout":_vm.logout}}),_c('router-view'),_c('Footer'),_c('toast',{attrs:{"position":"s"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }